export default "__VITE_ASSET__C5x5RJd3__"